<template>
  <div
    class="tag"
    :class="{
                'tag_btn': btn
            }"
    :style="{
                'padding-left': padding+'px',
                'padding-right': padding+'px',
                'background-color': getColor,
                'border-color': getBorderColor
            }"
    @click="click()"
  >
    <div
      class="tag__content"
      :class="{
        'tag__content_color-mix': this.colorMix
      }"
      :style="{
        'color': getTextColor,
      }"
    >{{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {type: String, default: '#fff'},
    colorImportant: {type: String, default: null},
    textColor: {type: String, default: '#000'},
    textColorImportant: {type: String, default: null},
    borderColor: {type: String, default: '#e3e3e3'},
    padding: {type: Number, default: 5},
    btn: {type: Boolean, default: false},
    colorMix: {type: Boolean, default: true},
    label: {type: String, default: null}
  },
  computed: {
    getColor() {
      if (this.colorImportant) {
        return this.colorImportant;
      }

      const item = this.$store.state.user.profile.tag.find(v => v.name === this.label);

      if (item === undefined) return this.color;

      return item.color;
    },
    getBorderColor() {
      const item = this.$store.state.user.profile.tag.find(v => v.name === this.label);

      if (item === undefined) return this.borderColor;

      return item.color;
    },
    getTextColor() {
      if (this.textColorImportant) {
        return this.textColorImportant;
      }

      const item = this.$store.state.user.profile.tag.find(v => v.name === this.label);

      if (item === undefined) return this.textColor;

      return item.text_color;
    }
  },
  methods: {
    click() {
      if (!this.btn) return;
      this.$emit('click');
    },
  },
}
</script>

<style lang="scss">
.tag {
  min-width: 22px;
  min-height: 18px;
  border: 1px solid #d6d6d6;
  border-radius: 15px;
  font-size: 11px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  user-select: none;

  &.tag_btn {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .tag__content {
    line-height: 11px;
    margin-top: -1px;

    &.tag__content_color-mix {
      //color: #fff;
      //mix-blend-mode: difference;
    }
  }
}
</style>